import { Action, getModule, Module, VuexModule } from 'vuex-module-decorators';

import httpService from '@/services/http';

import store from '.';
import { sessionStore } from './session';

export type Query = Record<string, any>;

@Module({
  name: 'queryStore',
  dynamic: true,
  namespaced: true,
  store,
})
export default class QueryStore extends VuexModule {
  @Action
  async create(query: Query): Promise<Query> {
    return (await httpService(sessionStore.session).post('/query/', query)).data;
  }

  @Action
  async findByPostalCode(cep: string): Promise<Query> {
    return (await httpService(sessionStore.session).get(`/query/cep/${cep}`)).data;
  }

  @Action
  async findByAddress({
    zipcode,
    address,
    country,
  }: {
    zipcode: string;
    address?: string;
    country?: string;
  }): Promise<Query> {
    return (
      await httpService(sessionStore.session).get(`/query/geocoder/${address || ''}`, {
        params: { zipcode, country },
      })
    ).data;
  }
}

export const queryStore = getModule<QueryStore>(QueryStore, store);
